export default __webpack_public_path__ + "media/images/linkedin-social-605c8e93bf419a00573f310d156ce3bf.svg";